import type { SVGProps } from "react";

const RELANCE_SIGNUP_URL =
  "https://relance.jp/signup/?utm_source=ai-relance&utm_medium=interview_complete&utm_campaign=post_interview";
const RELACOM_SIGNUP_URL =
  "https://comm.relance.jp/?utm_source=ai-relance&utm_medium=interview_complete&utm_campaign=post_interview";

function IconArrowRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function PostInterviewCta() {
  return (
    <div className="iv-next" data-testid="interview-next-actions">
      <div className="iv-next-divider" aria-hidden="true" />
      <p className="iv-next-intro">
        AI面談で登録いただいた情報を活用して、あなたに合った仕事探しを始められます。
      </p>
      <h2 className="iv-next-title">仕事探しの方法を選ぶ</h2>

      <a
        className="iv-next-card iv-next-card--lead"
        href={RELANCE_SIGNUP_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="リランスに無料会員登録する（新しいタブで開く）"
      >
        <span className="iv-next-body">
          <span className="iv-next-choice">相談しながら案件を探したい</span>
          <span className="iv-next-name">Relance（リランス）</span>
          <span className="iv-next-desc">
            専任エージェントが希望や経験に合わせて案件をご紹介します。
          </span>
        </span>
        <span className="iv-next-arrow">
          <IconArrowRight width={18} height={18} />
        </span>
      </a>

      <a
        className="iv-next-card"
        href={RELACOM_SIGNUP_URL}
        target="_blank"
        rel="noreferrer"
        aria-label="リラコムに無料登録する（新しいタブで開く）"
      >
        <span className="iv-next-body">
          <span className="iv-next-choice">企業から直接スカウトを受けたい</span>
          <span className="iv-next-name">RELACOMM（リラコム）</span>
          <span className="iv-next-desc">
            スキルシートを公開すると、企業から直接スカウト・オファーが届きます。
          </span>
        </span>
        <span className="iv-next-arrow">
          <IconArrowRight width={18} height={18} />
        </span>
      </a>

      <p className="iv-next-note">登録・利用はどちらも無料です</p>
    </div>
  );
}
